import React from "react";
import CardSimple from "screens/components/basic/CardSimple";

const SystemOverview = () => {
  return (
    <React.Fragment>
      <div id="major-features">
        <br />
        <div>
          <CardSimple>
            <div className="support-wrapper support-manual">
              <h2>Major Feature</h2>

              <h3>POS Sales</h3>
              <p>Here you can perform sales, refunds, and basic order management.</p>
              <hr />

              <h3>Users</h3>
              <p>
                Here you can manage your members, employees, vendors and doctors.
              </p>
              <hr />

              <h3>Inventory</h3>
              <p>
                Here you can manage your product catalog and inventory. You can
                create new products, edit the existing ones, create new Purchase
                Orders and manage your warehouse.
              </p>
              <hr />

              <h3>Pricing</h3>
              <p>
                Here you can define special campaigns, measurement settings
                and prices for each weight setting.
              </p>
              <hr />

              <h3>Admin</h3>
              <p>
                Here you can schedule shifts, keep track of the cash register, and
                see details of orders that have been placed. You can also access
                the general settings through the Admin tab.
              </p>
              <hr />

              <h3>Preferences</h3>
              <p>
                Here you can manage your cash registers, shifts, orders and
                application settings such as member discounts, age validation, and
                branch information.
              </p>
              <hr />

              <h3>Report</h3>
              <p>
                Here you can access the insights of your store, and monitor your sales, taxes, employee
                performance, cash and inventory levels.
              </p>
            </div>
          </CardSimple>
        </div>
      </div>
      <div id="getting-started">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Getting Started</h2>
            <h3>Setting up your account</h3>
            <ul>
              <li>
                The first thing you need in order to start using TechPOS is an
                account. Contact support to get your account set up!
              </li>
            </ul>
            <hr />

            <h3>Creating Products</h3>
            <ul>
              <li>
                Once you are set up with the product categories, weight settings
                and price matrix (see the corresponding sections in this
                document), go to Menu > Inventory > Product
              </li>
              <img src={require("./SupportDocImages/systemoverview_images/systemoverview1.PNG")} />
              <li>
                Click the Add button, located on the right side of the screen.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/createProd/CreateProd-2.png" />
              <li>Fill out the information and click on save.</li>
              <img
                src="http://techpos.ca/support-images/GettingStarted/createProd/CreateProd-3.png"
                width="600"
              />
            </ul>
            <hr />

            <h3>Creating Members</h3>
            <ul>
              <li>Go to Menu > User > Member</li>
              <img src="http://techpos.ca/support-images/GettingStarted/createMem/CreateMem-1.png" />
              <li>
                Click the Add button, located on the right side of the screen.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/createMem/CreateMem-2.png" />
              <li>
                Capture the photo of the Member, fill out the information and click
                save.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/createMem/CreateMem-3.png" />
              <li>NOTE: No underage Member is allowed in the system.</li>
              <img src="http://techpos.ca/support-images/GettingStarted/createMem/CreateMem-4.png" />
            </ul>
            <hr />

            <h3>Creating Employees</h3>
            <ul>
              <li>Go to Menu > User > Employee</li>
              <img src={require("./SupportDocImages/systemoverview_images/systemoverview2.PNG")} />
              <li>
                click the Add button, located on the right side of the screen.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/createEmp/CreateEmp-2.png" />
              <li>Fill out the information.</li>
              <img
                src="http://techpos.ca/support-images/GettingStarted/createEmp/CreateEmp-3.png"
                width="600"
              />
              <li>
                NOTE: Each employee email must be different as that one is going
                to be the username for login into the system. Click Save.
              </li>
              <img
                src="http://techpos.ca/support-images/GettingStarted/createEmp/CreateEmp-4.png"
                width="600"
              />
            </ul>
            <hr />

            <h3>Setting up a device</h3>
            <ul>
              <li>You need to set up a device in order to run POS Sales.</li>
              <li>Go to Menu > Preferences > Device</li>
              <img src={require("./SupportDocImages/systemoverview_images/systemoverview3.PNG")} />
              <li>Click on add a new device</li>
              <img src="http://techpos.ca/support-images/GettingStarted/setDevice/SetDevice-2.png" />
              <li>In the new screen, select the device type.</li>
              <img src="http://techpos.ca/support-images/GettingStarted/setDevice/SetDevice-3.png" />
              <li>
                Create a new role by clicking the button inside the toolbox or
                select one of the pre-existing ones.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/setDevice/SetDevice-4.png" />
              <li>
                Create a new workstation by clicking the button inside the
                toolbox or select one of the pre-existing ones.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/setDevice/SetDevice-5.png" />
              <li>
                Make sure that the status of the device is active and click on
                save.
              </li>
              <img src="http://techpos.ca/support-images/GettingStarted/setDevice/SetDevice-6.png" />
            </ul>
            <hr />

            <h3>Selling an item</h3>
            <ul>
              <li>
                In order to sell items, you must have items for sale in your
                warehouse, store employees, and registered members in the
                system. If you don't have those, please refer to the above
                sections on "Creating Members" and "Creating Employees."
              </li>
              <li>
                On the left hand side of the screen, you will see a button
                called Search Memeber -- click on it to search for a Member in
                case you are selling a Cannabis-infused item.
              </li>
              <li>Search for the Member either by name or Member number.</li>
              <li>
                NOTE: For security reasons, Member name must exactly match the
                name in the system.
              </li>
              <li>
                On the left side of the screen you will see a box containing all
                of the categories of the products in the store. You can search
                for your product there or by typing the name in the search bar.
              </li>
              <li>
                You can add the item to the order by clicking on it and choosing
                an amount (if it's a unit product) or by having the system read
                the weight from the scale.
              </li>
              <li>
                Once you are done, you can choose the payment method, enter the
                amount, and finally print the receipt.
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
    </React.Fragment>
  );
};

export default SystemOverview;
